import React, { ComponentState, useCallback, useContext } from "react";
import { CustomCellEditorProps } from "ag-grid-react";
import Autocomplete from "composants/autocomplete/AutoComplete";
import { Pojo } from "types/Galaxy";
import { WviContext } from "./Datatable";
import { get } from "lodash-es";
import { getOptionsByType } from "utils/component.utils";
import { DataInteractionContext } from "hooks/useInteractions";

export interface CellEditorAutocompleteProps {
  tableName: string;
  sjmoCode: string;
  ctrlKey: string;
  componentID: string;
  compo: ComponentState;
  columnIndex: number;
}

export function buildCellEditorAutocomplete({
  tableName,
  sjmoCode,
  ctrlKey,
  componentID,
  columnIndex,
  compo
}: CellEditorAutocompleteProps) {
  return ({ value, data, colDef, rowIndex, onValueChange, stopEditing }: CustomCellEditorProps) => {
    const wviState = useContext(WviContext);
    const wviStateCol = get(wviState, [data.id, colDef.colId, "type"]);

    const navigationParams = {
      "data-navigation-key": ctrlKey,
      "data-navigation-row": rowIndex,
      "data-navigation-column": columnIndex
    };
    const options = getOptionsByType(compo);

    // TODO: parser item change pour appeler onvaluechange avec les bonnes valeurs
    const onItemChange = useCallback(
      (itemChange: Pojo | null, name: string | undefined) => {
        onValueChange(itemChange);
      },
      [onValueChange]
    );

    const onBlur = useCallback(
      (entityId: string, columnName: string) => {
        stopEditing();
        //TODO ajouter l'appel au wvi si lorsqu'il le faut
      },
      [stopEditing]
    );

    return (
      <DataInteractionContext.Provider value={data}>
        <Autocomplete
          tableName={tableName}
          sjmoCode={sjmoCode}
          id={componentID}
          name={colDef.colId}
          value={value?.id}
          onItemChange={onItemChange}
          onBlur={() => onBlur(data.id, colDef.colId ?? "")}
          //onKeyDown={onKeyDown}
          onContextMenu={e => {}}
          joinTableName={compo.joinTableName}
          joinListFields={compo.joinListFields}
          additionalClause={compo.additionalClause}
          sortClause={compo.sortClause}
          readOnly={compo.isReadonly}
          disabled={compo.isDisabled}
          controlProps={{ expanded: true }}
          style={{ width: "100%" }}
          hasLov={compo.hasLov}
          wviState={wviStateCol}
          {...navigationParams}
          {...options}
        />
      </DataInteractionContext.Provider>
    );
  };
}
